import React, { useContext } from "react";
import { LeafletConsumer } from "react-leaflet";

const LeafletContext = React.createContext(null);

/*
 * This hook provides the current leaflet context
 */

export const LeafletProvider = (props: any) => {
  return (
    <LeafletConsumer>
      {(context) => {
        return (
          <LeafletContext.Provider value={context}>
            {props.children}
          </LeafletContext.Provider>
        );
      }}
    </LeafletConsumer>
  );
};

export default function useLeaflet(): any {
  const context = useContext(LeafletContext);
  return context;
}
